import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ViewIcon from "assets/icons/View.svg";
import BodyHeader from "../common/BodyHeader";
import PlusIcon from "assets/icons/Plus.svg";
import SearchBar from "../common/SearchBarActivities";
import GenericTable from "../common/GenericTable";
import Button from "@mui/material/Button";
import RetryIcon from "assets/icons/Retry.svg";

const TrackPayments = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const paymentHeaders = [
    "PAYMENT ID",
    "JOB TITLE",
    "VENDOR",
    "AMOUNT",
    "PAYMENT METHOD",
    "STATUS",
    "DATE PAID",
    "ACTIONS",
  ];

  const paymentRows = [
    {
      id: "PAY-00123",
      job: "HVAC Repair",
      vendor: "James Plumbing Co.",
      amount: "$250.00",
      method: "Bank Transfer",
      status: "Completed",
      date: "Dec 15, 2024",
    },
    {
      id: "PAY-00124",
      job: "Kitchen Faucet Repair",
      vendor: "AquaFix Services",
      amount: "$180.00",
      method: "Bank Transfer",
      status: "Failed",
      date: "Dec 22, 2024",
    },
    {
      id: "PAY-00125",
      job: "Window Fix",
      vendor: "CleanCo Contractors",
      amount: "$310.00",
      method: "Manual (Check)",
      status: "Failed",
      date: "Dec 15, 2024",
    },
    {
      id: "PAY-00126",
      job: "HVAC Repair",
      vendor: "James Plumbing Co.",
      amount: "$250.00",
      method: "Bank Transfer",
      status: "Completed",
      date: "Dec 15, 2024",
    },
    {
      id: "PAY-00127",
      job: "Kitchen Faucet Repair",
      vendor: "AquaFix Services",
      amount: "$180.00",
      method: "Bank Transfer",
      status: "Completed",
      date: "Dec 22, 2024",
    },
    {
      id: "PAY-00128",
      job: "Window Fix",
      vendor: "CleanCo Contractors",
      amount: "$310.00",
      method: "Manual (Check)",
      status: "Failed",
      date: "Dec 15, 2024",
    },
    {
      id: "PAY-00129",
      job: "HVAC Repair",
      vendor: "James Plumbing Co.",
      amount: "$250.00",
      method: "Bank Transfer",
      status: "Completed",
      date: "Dec 15, 2024",
    },
    {
      id: "PAY-00130",
      job: "Kitchen Faucet Repair",
      vendor: "AquaFix Services",
      amount: "$180.00",
      method: "Bank Transfer",
      status: "Completed",
      date: "Dec 22, 2024",
    },
    {
      id: "PAY-00131",
      job: "Window Fix",
      vendor: "CleanCo Contractors",
      amount: "$310.00",
      method: "Manual (Check)",
      status: "Failed",
      date: "Dec 15, 2024",
    },
    {
      id: "PAY-00132",
      job: "HVAC Repair",
      vendor: "James Plumbing Co.",
      amount: "$250.00",
      method: "Bank Transfer",
      status: "Completed",
      date: "Dec 15, 2024",
    },
  ];

  const renderPaymentCell = (row, header, colIdx) => {
    switch (header) {
      case "PAYMENT ID":
        return row.id;
      case "JOB TITLE":
        return row.job;
      case "VENDOR":
        return row.vendor;
      case "AMOUNT":
        return row.amount;
      case "PAYMENT METHOD":
        return row.method;
      case "STATUS":
        return (
          <span
            style={{
              display: "inline-block",
              padding: "2px 16px",
              borderRadius: 16,
              background: row.status === "Completed" ? "#E9F9EE" : "#FDEDED",
              color: row.status === "Completed" ? "#2ECC71" : "#F44336",
              fontWeight: 500,
              fontSize: 14,
              border:
                row.status === "Completed"
                  ? "1px solid #B6EFCB"
                  : "1px solid #F8C7C7",
            }}
          >
            {row.status}
          </span>
        );
      case "DATE PAID":
        return row.date;
      case "ACTIONS":
        return (
          <>
            <Button
              variant="outlined"
              size="small"
              onClick={(event) => handleManageClick(event, row)}
              style={{
                border: "1px solid #ECECEC",
                color: "#242424",
              }}
            >
              Manage
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && selectedInvoice?.id === row.id}
              onClose={handleMenuClose}
              MenuListProps={{
                "aria-labelledby": "manage-button",
              }}
              sx={{
                mt: 1,
                "& .MuiPaper-root": {
                  borderRadius: "12px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                  minWidth: "180px",
                },
              }}
            >
              <MenuItem
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontWeight: 500,
                  color: "#333333",
                }}
                onClick={() => handleMenuAction("view")}
              >
                <img src={ViewIcon}></img>
                View
              </MenuItem>
              {row.status === "Failed" && (
                <MenuItem
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontWeight: 500,
                    color: "#333333",
                  }}
                  onClick={() => handleMenuAction("download")}
                >
                  <img src={RetryIcon}></img>
                  Retry Now
                </MenuItem>
              )}
            </Menu>
          </>
        );
      default:
        return row[header.toLowerCase()];
    }
  };

  const handleManageClick = (event, invoice) => {
    setAnchorEl(event.currentTarget);
    setSelectedInvoice(invoice);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedInvoice(null);
  };

  const handleMenuAction = (action) => {
    console.log(`Action: ${action} for invoice:`, selectedInvoice);
    // Handle different actions here
    handleMenuClose();
  };

  return (
    <div className=" max-w-[1440px] m-auto md:py-12 py-8 md:px-6 px-4 ">
      <div className="pt-[70px]">
        <div className=" flex flex-col md:gap-12 gap-4 ">
          <BodyHeader
            title="Track Payments"
            description="Monitor payments made to vendors for completed jobs. View payment status, method, and linked jobs in one place."
          ></BodyHeader>
          <SearchBar
            label="Search payment"
            placeholder="Search by payment id, vendor name, job title"
            select={[
              { label: "Status", values: ["A", "B", "C"] },
              { label: "Date Range", values: ["A", "B", "C"] },
            ]}
          ></SearchBar>
          <div className="mt-6">
            <GenericTable
              resultsPerPage={10}
              headers={paymentHeaders}
              rows={paymentRows}
              renderCell={renderPaymentCell}
              pagination={null}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackPayments;
